import React, { type FC } from "react";

import DocumentValidationListing from "src/components/Pages/DocumentInbound/Tabs/Validations/DocumentCompliance/DocumentComplianceListing";

const DocumentCompliance: FC = () => {
  return <DocumentValidationListing />;
};

export default DocumentCompliance;
